/*
 * @Author: Wot
 * @Date: 2022-04-24 11:47:16
 * @LastEditors: DQL
 * @LastEditTime: 2022-10-09 17:39:32
 * @Description: file content
 */

import axios from 'axios';
import config from '@/config';

const { iffApi } = config.ctx;
export const mainService = {

  // 统计项目的数量
  getXmNumber: () => { return axios.get(`${iffApi}/zhxf/tj`); },
  bgList: () => { return axios.get(`${iffApi}/common/bg/get`); },
  getWbProcessList: () => { return axios.get(`${iffApi}/zhxf/tj/wbrw`); }

};
